export { InventoryListPage } from './view/inventory-list-page';

export { default as inventorySlice } from './slice';
export { inventorySagas } from './sagas';
